const NoMatch = () => <><h1>404: Not Found</h1></>;
export default NoMatch;